import { render, staticRenderFns } from "./CreditorWarrants.vue?vue&type=template&id=bd9f07ca&scoped=true"
import script from "./CreditorWarrants.vue?vue&type=script&lang=js"
export * from "./CreditorWarrants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9f07ca",
  null
  
)

export default component.exports